module.exports = {
  entry: './src/apps/roi-calculator-bank/index.tsx',
  shortcode: 'roi-calculator-bank',
  title: 'Roi Calculator Banking',
  status: 'stable',
  description: 'Calclator to mesure befefts of  WatsonX in banking',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-roi-calculator-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud', '/products', '/flashsystem'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
